export default __webpack_public_path__ + "static/gradebg2-9ec27ec914e110ef66040b921051d2f8.png";